import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Tv } from 'lucide-react';
import SeriesCard from './SeriesCard';
import { tvApi, languageToTMDB } from '../services/api';
import { useLanguage } from '../context/LanguageContext';

const SeriesSection = () => {
  const { t, language } = useLanguage();
  const [series, setSeries] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSeries = async () => {
      try {
        setLoading(true);
        const tmdbLang = languageToTMDB[language] || 'en-US';
        const data = await tvApi.getTrending('week', 1, tmdbLang);
        // Filter to only series with posters and get first 6
        const seriesWithPosters = data.results.filter(s => s.poster);
        setSeries(seriesWithPosters.slice(0, 6));
      } catch (error) {
        console.error('Error fetching TV series:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchSeries();
  }, [language]);

  if (loading) {
    return (
      <section className="bg-[#0d1411] py-24">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-[7.6923%]">
          <div className="animate-pulse">
            <div className="h-10 bg-[#1a2420] rounded w-64 mb-8" />
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-6">
              {[...Array(6)].map((_, i) => (
                <div key={i} className="aspect-[2/3] bg-[#1a2420] rounded-lg" />
              ))}
            </div>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className="bg-[#0d1411] py-24">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-[7.6923%]">
        {/* Section Header */}
        <div className="flex items-center justify-between mb-12">
          <div className="flex items-center gap-4">
            <Tv className="w-8 h-8 text-[#52ea88]" />
            <div>
              <h2 className="text-3xl md:text-4xl font-semibold text-[#E6FFF6]">
                {t('series.title') || 'Trending TV Series'}
              </h2>
              <p className="text-[#9FBFB4] mt-1">
                {t('series.subtitle') || 'Popular shows from streaming platforms'}
              </p>
            </div>
          </div>
          
          <Link
            to="/series"
            className="group flex items-center gap-2 text-[#52ea88] hover:text-[#E6FFF6] transition-colors"
          >
            <span>{t('series.viewAll') || 'View All'}</span>
            <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
          </Link>
        </div>

        {/* Series Grid */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-6">
          {series.map((show) => (
            <SeriesCard key={show.id} series={show} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default SeriesSection;
